"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.divider = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _core = require("@popperjs/core");

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _popperMaxSizeModifier = _interopRequireDefault(require("popper-max-size-modifier"));

var _Dropdown = _interopRequireDefault(require("./Dropdown.provider"));

var _DropdownMenu = _interopRequireDefault(require("./DropdownMenu"));

var _DropdownButton = _interopRequireDefault(require("./DropdownButton"));

var _elements = require("../../styles/elements");

var _Dropdown2 = require("./Dropdown.styles");

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var _util = require("../../util");

var _hooks = require("../../hooks");

var divider = (0, _jsxRuntime.jsx)("div", {
  css: _elements.divider.styles.base,
  role: "separator"
}); // Don't use hooks for this, it will cause Invalid Hook Call error if there are hooks inside the component (children)

exports.divider = divider;

var getElements = function getElements(children) {
  if (!children) return undefined;

  if (typeof children.type === 'function') {
    return children.type(children.props); // A component
  }

  if (children.type && typeof children.type.type === 'function') {
    return children.type.type(children.props); // A HOC component, like React.memo
  }

  return children; // Not a component
};

var Dropdown = function Dropdown(_ref) {
  var overlay = _ref.overlay,
      className = _ref.className,
      onSelect = _ref.onSelect,
      selectedKey = _ref.selectedKey,
      children = _ref.children,
      defaultVisible = _ref.defaultVisible,
      visible = _ref.visible,
      onVisibleChange = _ref.onVisibleChange,
      disabled = _ref.disabled,
      header = _ref.header,
      headerSticky = _ref.headerSticky,
      footer = _ref.footer,
      footerSticky = _ref.footerSticky,
      footerWithBtns = _ref.footerWithBtns,
      hasMinWidth = _ref.hasMinWidth,
      autoHeight = _ref.autoHeight,
      heightConstraints = _ref.heightConstraints,
      position = _ref.position,
      emptyHint = _ref.emptyHint,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      strategy = _ref.strategy,
      portal = _ref.portal,
      menuHeight = _ref.menuHeight,
      isNavByArrowsDisabled = _ref.isNavByArrowsDisabled,
      menuItemIconHidden = _ref.menuItemIconHidden,
      offset = _ref.offset,
      onClick = _ref.onClick;
  var popperRef = (0, _react.useRef)(null);
  var popperInstanceRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(); // Track which item is highlighted when navigate items through arrow up / arrow down

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      highlightedItemKey = _useState2[0],
      setHighlightedItemKey = _useState2[1]; // Track whether an item has highlighted by arrows
  // so can use it to remove hover styles for other items


  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hasItemHighlightedByArrow = _useState4[0],
      setHasItemHighlightedByArrow = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultVisible),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      open = _useState6[0],
      setOpen = _useState6[1]; // Verifies that children has only one child (a React element) and returns it.


  var childElement = _react["default"].Children.only(children);

  var triggerRef = (0, _react.useRef)(null);
  var modifiers = (0, _react.useMemo)(function () {
    return [_popperMaxSizeModifier["default"], {
      name: 'offset',
      options: {
        offset: Array.isArray(offset) ? offset : [0, offset]
      }
    }, {
      name: 'applyMaxSize',
      enabled: !!heightConstraints,
      phase: 'beforeWrite',
      requires: ['maxSize'],
      fn: function fn(_ref2) {
        var state = _ref2.state;
        var _heightConstraints$mi = heightConstraints.min,
            autoMin = _heightConstraints$mi === void 0 ? 0 : _heightConstraints$mi,
            _heightConstraints$ma = heightConstraints.max,
            autoMax = _heightConstraints$ma === void 0 ? 0 : _heightConstraints$ma;
        var height = state.modifiersData.maxSize.height;
        var maxHeight = Math.min(height, autoMax);
        var minHeight = Math.min(maxHeight, autoMin); // eslint-disable-next-line no-param-reassign

        state.styles.popper.maxHeight = "".concat(maxHeight, "px"); // eslint-disable-next-line no-param-reassign

        state.styles.popper.minHeight = "".concat(minHeight, "px");
      }
    }];
  }, [offset, heightConstraints]);
  var menuHeightCss = (0, _react.useMemo)(function () {
    return _Dropdown2.styles.overrideMenuHeight(menuHeight);
  }, [menuHeight]);
  var handleArrowEvent = (0, _react.useCallback)(function (e, highlightedKey) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation(); // prevent trigger the document's keydown event

    e.preventDefault(); // prevent scroll in the document

    setHighlightedItemKey(highlightedKey);
    setHasItemHighlightedByArrow(true);
  }, []);

  var _useDropdownKeyboard = (0, _hooks.useDropdownKeyboard)({
    open: open,
    overlay: getElements(overlay),
    prop: 'itemKey',
    highlightedItemKey: highlightedItemKey,
    setHighlightedItemKey: setHighlightedItemKey,
    handleArrowEvent: handleArrowEvent,
    selectedKey: selectedKey,
    isNavByArrowsDisabled: isNavByArrowsDisabled
  }),
      handleKeyDown = _useDropdownKeyboard.handleKeyDown,
      onKeyUp = _useDropdownKeyboard.onKeyUp;

  var show = (0, _react.useCallback)(function () {
    var skipOnVisibleChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setOpen(true);

    if (!skipOnVisibleChange) {
      onVisibleChange(true);
    }

    if (!(popperInstanceRef !== null && popperInstanceRef !== void 0 && popperInstanceRef.current)) return;
    /* Enable the event listeners for updating position
     ** setOptions for modifiers will overwrite others modifiers
     * so need to merge with the default modifiers
     */

    popperInstanceRef.current.setOptions({
      modifiers: [].concat((0, _toConsumableArray2["default"])(modifiers), [{
        name: 'eventListeners',
        enabled: true
      }])
    }); // Update its position

    popperInstanceRef.current.update();
  }, [modifiers, onVisibleChange]);
  var hide = (0, _react.useCallback)(function () {
    var _popperInstanceRef$cu;

    var skipOnVisibleChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setOpen(false);

    if (!skipOnVisibleChange) {
      onVisibleChange(false);
    } // Disable the event listeners for updating position when the popup is hidden


    (_popperInstanceRef$cu = popperInstanceRef.current) === null || _popperInstanceRef$cu === void 0 ? void 0 : _popperInstanceRef$cu.setOptions({
      modifiers: [].concat((0, _toConsumableArray2["default"])(modifiers), [{
        name: 'eventListeners',
        enabled: false
      }])
    });
  }, [modifiers, onVisibleChange]); // Handle click trigger

  var handleClickTrigger = (0, _react.useCallback)(function () {
    if (disabled) return;

    if (open) {
      hide();
    } else {
      show();
    }
  }, [disabled, open, show, hide]);
  var handleKeyDownTrigger = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, handleClickTrigger, true);
  }, [handleClickTrigger]); // If click outside the dropdown button or display area
  // Close the dropdown

  var handleClickOutside = (0, _react.useCallback)(function (event) {
    var path = event.path || event.composedPath && event.composedPath();

    if (!path.includes(triggerRef.current) && !path.includes(popperRef.current)) {
      hide();
    }
  }, [hide]);
  var handleSelect = (0, _react.useCallback)(function () {
    if (triggerRef && triggerRef.current) {
      // Focus the trigger element when select an item
      // so can use enter key to open the menu
      triggerRef.current.focus();
    }

    hide();
    onSelect.apply(void 0, arguments);
  }, [hide, onSelect]);
  var handleKeyUp = (0, _react.useCallback)(function (e) {
    if (!open) return;

    var handleEscape = function handleEscape() {
      // Escape key, close the dropdown
      hide();
      triggerRef.current.focus();
    };

    onKeyUp(e, {
      handleEscape: handleEscape
    });
  }, [open, hide, onKeyUp]);
  var handleClickMenuWithButton = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    onClick(e);
  }, [onClick]);
  (0, _react.useEffect)(function () {
    if (open) {
      // Use mousedown instead click,
      // because click event will close the menu if we select text in the menu and end the selection outside
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keyup', handleKeyUp);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keyup', handleKeyUp);
    }

    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [open, handleClickOutside, handleKeyUp]);
  var initiallyUncontrolled = (0, _react.useRef)(visible === undefined);
  (0, _react.useEffect)(function () {
    if (visible !== undefined && initiallyUncontrolled.current) {
      throw Error('Dropdown component changed from un-controlled to controlled. You must choose one or the other.');
    }

    if (visible === undefined && initiallyUncontrolled.current === false) {
      throw Error('Dropdown component changed from controlled to un-controlled. You must choose one or the other.');
    }

    if (initiallyUncontrolled.current) return;

    if (visible === true) {
      show(true);
    } else if (visible === false) {
      hide(true);
    }
  }, [initiallyUncontrolled, visible, show, hide]);
  (0, _react.useLayoutEffect)(function () {
    var _popperInstanceRef$cu2;

    (_popperInstanceRef$cu2 = popperInstanceRef.current) === null || _popperInstanceRef$cu2 === void 0 ? void 0 : _popperInstanceRef$cu2.destroy();
    popperInstanceRef.current = null;

    if (open) {
      var triggerElement = triggerRef.current;
      var popperElement = popperRef.current;
      popperInstanceRef.current = (0, _core.createPopper)(triggerElement, popperElement, {
        placement: position,
        modifiers: modifiers,
        strategy: strategy
      });
    }

    return function () {
      var _popperInstanceRef$cu3;

      (_popperInstanceRef$cu3 = popperInstanceRef.current) === null || _popperInstanceRef$cu3 === void 0 ? void 0 : _popperInstanceRef$cu3.destroy();
      popperInstanceRef.current = null;
    };
  }, [open, modifiers, position, strategy, triggerRef]);
  var dropdownContent = open ? (0, _jsxRuntime.jsxs)("div", {
    ref: popperRef,
    css: [_Dropdown2.styles.dropdownContainer, hasMinWidth && _Dropdown2.styles.minWidth, open && _Dropdown2.styles.visible, autoHeight === true && _Dropdown2.styles.autoH, strategy === 'fixed' && _Dropdown2.styles.autoWidth, !autoHeight && menuHeightCss, menuItemIconHidden && _Dropdown2.styles.menuItemIconHidden, process.env.NODE_ENV === "production" ? "" : ";label:dropdownContent;"],
    className: (0, _clsx["default"])('grui box-shadow-md', className, footerSticky && 'pb-0', headerSticky && 'pt-0'),
    children: [header && (0, _jsxRuntime.jsxs)("header", {
      css: headerSticky && _Dropdown2.styles.headerSticky,
      children: [(0, _jsxRuntime.jsx)("div", {
        css: _Dropdown2.styles.header,
        children: header
      }), divider]
    }), overlay, footer && (0, _jsxRuntime.jsxs)("footer", {
      css: footerSticky && _Dropdown2.styles.footerSticky,
      children: [divider, (0, _jsxRuntime.jsx)("div", {
        css: [_Dropdown2.styles.footer, footerWithBtns && _Dropdown2.styles.footerWithBtns, process.env.NODE_ENV === "production" ? "" : ";label:dropdownContent;"],
        children: footer
      })]
    })]
  }) : null;
  var wrappedContent;

  if (dropdownContent && portal) {
    wrappedContent = /*#__PURE__*/_reactDom["default"].createPortal(dropdownContent, document.querySelector(portal));
  } else if (dropdownContent) {
    wrappedContent = dropdownContent;
  } else {
    wrappedContent = null;
  }

  return (0, _jsxRuntime.jsx)(_Dropdown["default"], {
    onSelect: handleSelect,
    selectedKey: selectedKey,
    open: open,
    emptyHint: emptyHint,
    triggerRef: triggerRef,
    containerRef: containerRef,
    highlightedItemKey: highlightedItemKey,
    setHighlightedItemKey: setHighlightedItemKey,
    hasItemHighlightedByArrow: hasItemHighlightedByArrow,
    setHasItemHighlightedByArrow: setHasItemHighlightedByArrow,
    isNavByArrowsDisabled: isNavByArrowsDisabled,
    children: (0, _jsxRuntime.jsxs)("div", {
      css: _Dropdown2.styles.base,
      ref: containerRef,
      onKeyDown: open ? handleKeyDown : undefined,
      onClick: handleClickMenuWithButton,
      role: "presentation",
      children: [/*#__PURE__*/(0, _react.cloneElement)(childElement, {
        disabled: disabled,
        ref: triggerRef,
        onClick: handleClickTrigger,
        onKeyDown: handleKeyDownTrigger,
        className: (0, _clsx["default"])(childElement.props.className, 'trigger')
      }), wrappedContent, help && (0, _jsxRuntime.jsx)(_Help["default"], {
        help: help,
        validateStatus: validateStatus
      })]
    })
  });
};

Dropdown.propTypes = {
  /**
   * Dropdown overlay
   */
  overlay: _propTypes.element,
  className: _propTypes.string,

  /**
   * select option handler
   */
  onSelect: _propTypes.func,

  /**
   * Selected item key: for highlighting selected item
   */
  selectedKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  children: _propTypes.node,
  defaultVisible: _propTypes.bool,

  /**
   * Control the visibility of Dropdown </br>
   * need to pass onVisibleChange together to be called when the open state is changed
   * If it's not provided, will use the open state to control the visibility
   */
  visible: _propTypes.bool,
  onVisibleChange: _propTypes.func,
  disabled: _propTypes.bool,

  /**
   * Dropdown overlay header
   */
  header: _propTypes.node,
  headerSticky: _propTypes.bool,

  /**
   * Dropdown overlay footer
   */
  footer: _propTypes.node,
  footerSticky: _propTypes.bool,
  footerWithBtns: _propTypes.bool,

  /**
   * Whether to set min-width (240) for dropdown menu </br>
   * if false, the width will be the same as the dropdown button </br>
   * or pass className to custom the style
   */
  hasMinWidth: _propTypes.bool,

  /**
   * Whether to remove overflow-hidden for dropdown-menu
   */
  autoHeight: _propTypes.bool,

  /**
   * Soft constraints for height
   */
  heightConstraints: (0, _propTypes.shape)({
    min: _propTypes.number,
    max: _propTypes.number
  }),

  /**
   * Menu height in px
   */
  menuHeight: _propTypes.number,

  /**
   * Position of dropdown menu
   * https://popper.js.org/docs/v2/constructors/#options
   */
  position: (0, _propTypes.oneOf)(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),
  emptyHint: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,

  /**
   * Drodown menu's position style value
   * only change it when the dropdown is inside a scrollable or hidden container
   * because fixed menu won't get the width of its trigger element like a normal dropdown
   */
  strategy: (0, _propTypes.oneOf)(['absolute', 'fixed']),

  /**
   * CSS selector for portal to render overlay within
   */
  portal: _propTypes.string,

  /**
   * Whether to disable navigation by up/down arrows
   * Diable it when one of the customized menu item can't forward ref
   */
  isNavByArrowsDisabled: _propTypes.bool,

  /**
   * Whether to hide menu item arrow icons
   */
  menuItemIconHidden: _propTypes.bool,

  /**
   * The distances(px) between trigger and the dropdown menu;
   * if it's an array: the first number is for x, the second one is for y;
   * otherwise, it is for y
   */
  offset: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),

  /**
   * Handle click the whole dropdown (button + menu)
   */
  onClick: _propTypes.func
};
Dropdown.defaultProps = {
  className: undefined,
  onSelect: function onSelect() {},
  selectedKey: undefined,
  defaultVisible: false,
  visible: undefined,
  onVisibleChange: function onVisibleChange() {},
  disabled: false,
  header: undefined,
  headerSticky: false,
  footer: undefined,
  footerSticky: false,
  footerWithBtns: false,
  hasMinWidth: false,
  autoHeight: false,
  heightConstraints: undefined,
  menuHeight: 300,
  position: 'bottom-start',
  emptyHint: undefined,
  overlay: (0, _jsxRuntime.jsx)(_DropdownMenu["default"], {}),
  children: undefined,
  help: undefined,
  validateStatus: undefined,
  strategy: 'absolute',
  portal: undefined,
  isNavByArrowsDisabled: false,
  menuItemIconHidden: false,
  offset: 5,
  onClick: function onClick() {}
};
Dropdown.Menu = _DropdownMenu["default"];
Dropdown.Button = _DropdownButton["default"];
var _default = Dropdown;
exports["default"] = _default;
//# sourceMappingURL=Dropdown.js.map